import { i18nConfig } from '../../next-i18next.config';

const LOCALE_SLUG = /^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i;
// Last-resort slug when the path, cookie and route param are all missing or unsupported.
const DEFAULT_SLUG = 'en-GB';
const NEXT_LOCALE_COOKIE = /(?:^|; )NEXT_LOCALE=([^;]*)/;

// Same validation the proxy applies: supported language and region, canonical casing.
const normalizeLocale = (value) => {
    const match = value?.match(/^([a-z]{2})-([a-z]{2})$/i);
    if (!match) return null;
    const [, lang, region] = match;
    const language = lang.toLowerCase();
    const upperRegion = region.toUpperCase();
    const isSupported = i18nConfig.locales.includes(language) && i18nConfig.regions.includes(upperRegion);
    return isSupported ? `${language}-${upperRegion}` : null;
};

const decode = (value) => {
    try {
        return decodeURIComponent(value);
    } catch {
        return null;
    }
};

/**
 * Resolves the full locale slug (e.g. 'de-DE') to use when building internal links.
 *
 * The browser path is authoritative: the proxy rewrites every page to /nl-NL internally,
 * so the `lang` route param is always 'nl-NL' and must only be the last resort.
 * Unsupported values are skipped, so a bad cookie can never produce a broken link.
 */
export const resolveLangSlug = ({ pathname, cookie, paramLang } = {}) => {
    const fromPath = normalizeLocale(pathname?.match(LOCALE_SLUG)?.[1]);
    if (fromPath) return fromPath;

    const rawCookie = cookie?.match(NEXT_LOCALE_COOKIE)?.[1];
    const fromCookie = normalizeLocale(rawCookie && decode(rawCookie));
    if (fromCookie) return fromCookie;

    return normalizeLocale(paramLang) || DEFAULT_SLUG;
};
